export const PrereqPopupContent = [
    {
        id : 1,
        designation : 'Social Media Influencer Intern Pre-Requisite',
        content : (
            <ul className="prerequisites-list">
          <li>Strong presence and engagement across major social media platforms.</li>
          <li>Excellent communication skills with an authentic, relatable voice.</li>
          <li>Ability to create engaging content, including photos, videos, and stories.</li>
          <li>Knowledge of current social media trends and analytics tools.</li>
          <li>Creative mindset with a passion for automotive content (or relevant niche).</li>
          <li>Ability to collaborate with teams and maintain brand consistency.</li>
        </ul>
        ),
        salary : 'Upto 15K',
        experience : '0 to 1 Year',
        openings : '1',
        type : 'Internship'
    },
    {
        id : 2,
        designation : 'Video Editing Intern Pre-requisites',
        content : (
            <ul className="prerequisites-list">
          <li>Proficiency in video editing software like Adobe Premiere Pro.</li>
          <li>UX Creativity & Flow Must Be Better.</li>
          <li>Managing Files In An Arranged Standard Way.</li>
          <li>Ability To Understand Client's Or Project's Requirements/Changes.</li>
          <li>Hands-On Experience On Working With Localhost And Server.</li>
          <li>Knowledge Of Media Queries And Multi OS/Device Platforms.</li>
        </ul>
        ),
        salary : 'Upto 15K',
        experience : '6 Months - 1 Year',
        openings : '1',
        type : 'Internship'
    },
    {
        id : 3,
        designation : 'Automotive Content Writer Intern',
        content : (
            <ul className="prerequisites-list">
          <li>Strong writing skills with a passion for automotive topics.</li>
          <li>Ability to research and create accurate, engaging content.</li>
          <li>Familiarity with SEO best practices and keyword usage.</li>
          <li>Basic understanding of content management systems (e.g., WordPress).</li>
          <li>Attention to detail and commitment to producing high-quality work.</li>
          <li>Ability to adapt writing style to match brand voice and audience.</li>
        </ul>
        ),
        salary : 'Upto 10K',
        experience : '0 to 1 Year',
        openings : '1',
        type : 'Internship'
    },
];